<template>
  <figure ref="scene" class="event-launch-sculpture" :class="{ 'is-compact': compact }">
    <div class="fq-art">
      <div class="fq-sculpture">
        <div class="fq-fallback" aria-hidden="true"><canvas width="232" height="232" data-qr-fallback></canvas></div>
        <canvas class="fq-canvas" width="520" height="420" role="img" aria-label="Una escultura plateada con reflejos violetas se transforma en escenario, entrada y QR."></canvas>
        <canvas class="fq-canvas fq-pixels" width="520" height="420" aria-hidden="true"></canvas>
      </div>
    </div>
    <figcaption><span v-if="!compact">DE TU IDEA AL ESCENARIO</span><div class="fq-controls" aria-label="Movimiento de la escultura"><FomoButton variant="text" data-replay><span aria-hidden="true">↺</span> Repetir QR</FomoButton><FomoButton variant="text" data-pause aria-pressed="false"><span data-pause-symbol aria-hidden="true">Ⅱ</span> <span data-pause-text>Pausar</span></FomoButton></div></figcaption>
    <span class="fq-status" role="status" aria-live="polite" data-status></span>
  </figure>
</template>
<script>
import FomoButton from '@/components/ui/FomoButton.vue'
import { createFomoLiquidHero } from './createFomoLiquidHero'
export default {
  components: { FomoButton },
  props: { compact: { type: Boolean, default: false } },
  mounted() { this.disposeAnimation = createFomoLiquidHero(this.$refs.scene, { initialTime: 7.5 }) },
  beforeUnmount() { this.disposeAnimation?.(); this.disposeAnimation = null },
}
</script>
<style scoped>
.event-launch-sculpture{position:relative;isolation:isolate;min-width:0;margin:0;color:var(--fomo-dashboard-text)}
.fq-art{position:relative;width:100%;height:440px}.fq-sculpture{position:absolute;inset:0}.fq-canvas{position:absolute;inset:0;display:block;width:100%;height:100%}
.fq-fallback{position:absolute;inset:0;display:grid;place-items:center}.fq-fallback canvas{width:230px;height:230px;max-width:80%;image-rendering:pixelated}
[data-webgl='true'] .fq-fallback{display:none}
figcaption{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px 16px;padding:8px 20px}
figcaption>span{font:9px/1.5 var(--fomo-font-label);letter-spacing:.12em;color:var(--fomo-dashboard-copy)}
.fq-controls{display:flex;gap:16px;align-items:center}.fq-controls .fomo-button{font-size:11px;padding:8px 0;min-height:44px}.fq-controls :deep(span){font-family:inherit;font-size:inherit}
.fq-status{position:absolute;width:1px;height:1px;overflow:hidden;clip-path:inset(50%)}
.is-compact .fq-art{height:250px}.is-compact figcaption{padding-inline:0;justify-content:flex-end}
@media(max-width:700px){.fq-art{height:340px}figcaption{justify-content:center;padding:0 8px}.is-compact .fq-art{height:240px}.is-compact figcaption{justify-content:space-between}.is-compact figcaption>span{max-width:95px}}
</style>
